var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIconHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3818 7.74011C15.5817 8.48996 16.1815 8.86488 16.3873 9.34496C16.5669 9.76413 16.5669 10.2387 16.3873 10.658C16.1815 11.138 15.5817 11.5129 14.3818 12.2628L8.74667 15.7848C7.41505 16.617 6.74923 17.0332 6.19978 16.989C5.72085 16.9505 5.28182 16.7072 4.99534 16.3215C4.66667 15.879 4.66667 15.0938 4.66667 13.5235V6.47944C4.66667 4.90912 4.66667 4.12397 4.99534 3.68145C5.28182 3.29571 5.72085 3.05239 6.19978 3.01388C6.74923 2.96971 7.41505 3.38585 8.74667 4.21811L14.3818 7.74011Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconHollow);
export default __webpack_public_path__ + "static/media/play-icon-hollow.e917e90a4b958dfb445dd0b4deb81e04.svg";
export { ForwardRef as ReactComponent };